/**
 * 新規セクションVO
 *
 * @export NewSectionModel
 * @class NewSectionModel
 */
export class NewSectionModel {
  // 媒体グループID
  public sectionName = String('');
  public divH = Number(1);
  public divW = Number(1);
}
